import xss from 'xss';

export const validateUrl = (str) => {
  if (str) {
    return xss(str);
  }
  return '';
};

export const noHTML = (text) => xss(text, {
  whiteList: [], // empty, means filter out all tags
  stripIgnoreTag: true, // filter out all HTML not in the whitelist
  stripIgnoreTagBody: ['script'], // the script tag is a special case, we need to filter out its content
});
